import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { scrollToId } from "./Smooth";
import { useLang } from "../../lib/i18n";

export const Header = () => {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const links = [["benefits", t.nav.benefits], ["origin", t.nav.origin], ["use", t.nav.use], ["faq", t.nav.faq]];
  const dark = false;

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-[#FBF7EF]/85 backdrop-blur-xl border-[#073B4C]/10 text-[#073B4C]" : "bg-transparent border-transparent text-[#073B4C]"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-10">
        <button onClick={() => window.scrollTo({ top: 0 })} data-testid="header-logo-btn" aria-label="Mareia">
          <Logo light={dark} />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {links.map(([id, label]) => (
            <button key={id} onClick={() => scrollToId(id)} data-testid={`nav-${id}`}
              className="text-sm opacity-80 transition-opacity hover:opacity-100">{label}</button>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex rounded-full border border-current/20 p-0.5 font-mono-x text-xs" data-testid="lang-switch">
            {["fr", "en"].map((l) => (
              <button key={l} onClick={() => setLang(l)} data-testid={`lang-${l}`}
                className={`rounded-full px-2.5 py-1 uppercase transition-colors ${lang === l ? (dark ? "bg-[#7ED9D2] text-[#073B4C]" : "bg-[#073B4C] text-[#FBF7EF]") : "opacity-70"}`}>
                {l}
              </button>
            ))}
          </div>
          <button onClick={() => scrollToId("order")} data-testid="header-order-btn"
            className={`rounded-full px-4 py-2 text-sm font-semibold transition-[transform,background-color] hover:-translate-y-0.5 ${dark ? "bg-[#7ED9D2] text-[#073B4C]" : "bg-[#0A7189] text-[#FBF7EF]"}`}>
            {t.nav.order}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
